import React, { useEffect, useState } from 'react';
import { useLocale } from '../i18n/LocaleContext';
import { ArrowUpIcon } from './Icons';

const SHOW_AFTER_PX = 700;

export default function ScrollToTop() {
  const { t } = useLocale();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let frame = null;

    const onScroll = () => {
      if (frame !== null) {
        return;
      }
      // rAF-throttled: scroll fires far more often than the state needs to change.
      frame = requestAnimationFrame(() => {
        frame = null;
        setVisible(window.scrollY > SHOW_AFTER_PX);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame !== null) {
        cancelAnimationFrame(frame);
      }
    };
  }, []);

  return (
    <button
      type="button"
      className={`to-top${visible ? ' to-top--visible' : ''}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label={t('results.toTop')}
      title={t('results.toTop')}
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
    >
      <ArrowUpIcon size={17} />
      <span className="to-top__label">{t('results.toTop')}</span>
    </button>
  );
}
